'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.filter')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.function.name')
require('core-js/modules/es.object.keys')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _obj = require('../obj')

var _funcs = require('./funcs')
var StorageAdapter = /*#__PURE__*/ (function() {
  function StorageAdapter(arg) {
    ;(0, _defineProperty2.default)(this, 'name', void 0)
    ;(0, _defineProperty2.default)(this, 'type', void 0)
    this.name = arg.name
    this.type = (0, _funcs.getNativeType)(arg.type)
  }
  var _proto = StorageAdapter.prototype
  _proto.getItem = function getItem() {
    return (0, _funcs.getItem)(this.name, this.type)
  }
  _proto.setItem = function setItem(val) {
    return (0, _funcs.setItem)(this.name, val, this.type)
  }
  _proto.removeItem = function removeItem() {
    return (0, _funcs.removeItem)(this.name, this.type)
  }
  _proto.getProp = function getProp(propName) {
    var itemResult = this.getItem()
    if (itemResult.isValid && !itemResult.isEmpty) {
      return { hasProp: true, value: itemResult.value[propName] }
    }

    return { hasProp: false, value: null }
  }
  _proto.setProp = function setProp(propName, val) {
    var itemResult = this.getItem()
    var itemVal = (0, _obj.castObj)(itemResult.value)

    if (val === itemVal[propName]) {
      return {
        isWritten: false,
        reason: 'not changed'
      }
    }

    itemVal[propName] = val

    return this._write(itemVal, [propName])
  }
  _proto.setProps = function setProps(newProps) {
    var itemResult = this.getItem()
    var itemVal = (0, _obj.castObj)(itemResult.value)

    var newPropNames = Object.keys(newProps)
    var changedPropsNames = newPropNames.filter(function(propName) {
      return itemVal[propName] !== newProps[propName]
    })

    if (changedPropsNames.length === 0) {
      return {
        isWritten: false,
        reason: 'not changed'
      }
    }

    changedPropsNames.forEach(function(propName) {
      itemVal[propName] = newProps[propName]
    })

    return this._write(itemVal, changedPropsNames)
  }
  _proto.removeProp = function removeProp(propName) {
    var itemResult = this.getItem()
    if (!itemResult.isValid || itemResult.isEmpty || !(0, _obj.hasProp)(itemResult.value, propName))
      return { isWritten: false, reason: 'has no prop' }

    var itemVal = itemResult.value
    delete itemVal[propName]

    return this._write(itemVal, [propName])
  }
  _proto.removeProps = function removeProps(propNames) {
    var itemResult = this.getItem()

    if (!itemResult.isValid || itemResult.isEmpty) return { isWritten: false, reason: 'has no prop' }

    var itemVal = itemResult.value

    var propsToRemove = propNames.filter(function(propName) {
      return (0, _obj.hasProp)(itemVal, propName)
    })

    if (propsToRemove.length === 0) return { isWritten: false, reason: 'has no prop' }

    propsToRemove.forEach(function(propName) {
      delete itemVal[propName]
    })

    return this._write(itemVal, propsToRemove)
  }
  _proto._write = function _write(newItemVal, affectedProps) {
    var isWritten = this.setItem(newItemVal)

    return isWritten
      ? { isWritten: true, affectedProps: affectedProps }
      : { isWritten: false, reason: 'stringify error' }
  }
  _proto.destroy = function destroy() {
    return this
  }
  return StorageAdapter
})()
exports.default = StorageAdapter



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Storages/Adapter.js
// module id = 216
// module chunks = 0